import {
    GetOtherFormsGatePassByID, GetOtherFormsGatePassItemsByID, GetOtherFormsManualInvoiceByID, GetOtherFormsManuallyInvoiceItemsByID, GetOtherFormsMaterialOutByID, GetOtherFormsMaterialOutItemsByID, usp_Extra_GatePassCount, usp_Extra_Invoice_ManuallyCount, USP_OtherForms_GatePassInsertUpdate, USP_OtherForms_ManuallyInvoiceInsertUpdate, USP_OtherForms_MaterialOutInsertUpdate, usp_Transaction_MaterialOutCount,
    GetAllDropdownAndCountsForOtherForms,
    USP_Transaction_MaterialOutSelect_ForMaterialIn,
    USP_Extra_GatePassSelectbyId,
    USP_Transaction_MaterialOutSelectbyId,
    USP_Transaction_MaterialInInsertUpdate,
    USP_Transaction_MaterialInSelectbyId,
    USP_Master_ProductSelect_ForProductionStock,
    USP_Transaction_SalesReturn_ForDisAssemble,
    USP_Master_ProductSelect_ForProductionStock2,
    USP_Transaction_DeliveryChallanProductQuantitySelectByID,
    USP_Transaction_SalesReturnProductsSelectbyId,
    USP_Master_ItemSelectbyId_ForDisAssemble,
    USP_Master_ProductReceipeSelect_ForDisAssembleItem,
    USP_Master_ProductReceipeSelect_ForSalesReturnItem,
    USP_Transaction_DisAssembleSelectbyId,
    USP_Transaction_DisAssembleInsertUpdate,
    USP_Transaction_WorkOrderRecvSelectbyId_PendingQty_ForStockTransfer,
    USP_Transaction_StockTransferSelectbyId,
    USP_Transaction_StockTransferInsertUpdate,
    usp_Extra_EmployeeProblemSelectById,
    usp_Extra_EmployeeProblemInsertUpdate,
    usp_Master_ItemSelectForLocationTransfer,
    usp_Master_ProductReceipeSelectbyIdItemForStoreInPlant,
    usp_Master_ItemSelectByIdItemForTransferLocationStock,
    usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM,
    usp_Transaction_TransferLocationInsertUpdate,
    usp_Transaction_TransferLocationSelectById,
    usp_Transaction_TransferLocationSelectTransferNo,
    usp_Transaction_TransferLocationSelectByIdForInward,
    usp_Transaction_TransferLocationInwardInsertUpdate,
    usp_Transaction_TransferLocationInwardSelectById,
    usp_Transaction_TransferLocationCount,
    usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM_Print,
} from "../ApiEndPoints_1";
import { axiosGetAuthorize, axiosGetFileAuthorizeblob, axiosGetMultiParams, axiosPostAuthorize } from "../AxiosRequests";


export default class OtherFormsServices {

    // Material Out
    async getInvoiceCountForMaterialOut(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialOutCount, request);
    }

    async submitMaterialOutInsertUpdate(request) {
        return axiosPostAuthorize(USP_OtherForms_MaterialOutInsertUpdate, request);
    }

    async getOtherFormsMaterialOutByID(request) {
        return axiosGetAuthorize(GetOtherFormsMaterialOutByID, request);
    }

    async getOtherFormsMaterialOutItemsByID(request) {
        return axiosGetAuthorize(GetOtherFormsMaterialOutItemsByID, request);
    }

    // Gate Pass
    async getInvoiceCountForGatepass(request) {
        return axiosGetAuthorize(usp_Extra_GatePassCount, request);
    }

    async submitGatePassInsertUpdate(request) {
        return axiosPostAuthorize(USP_OtherForms_GatePassInsertUpdate, request);
    }

    async getOtherFormsGatePassByID(request) {
        return axiosGetAuthorize(GetOtherFormsGatePassByID, request);
    }

    async getOtherFormsGatePassItemsByID(request) {
        return axiosGetAuthorize(GetOtherFormsGatePassItemsByID, request);
    }

    // Manually Invoice
    async getInvoiceCountForManualInvoice(request) {
        return axiosGetAuthorize(usp_Extra_Invoice_ManuallyCount, request);
    }

    async submitManuallyInvoiceInsertUpdate(request) {
        return axiosPostAuthorize(USP_OtherForms_ManuallyInvoiceInsertUpdate, request);
    }

    async getOtherFormsManualInvoiceByID(request) {
        return axiosGetAuthorize(GetOtherFormsManualInvoiceByID, request);
    }

    async getOtherFormsManuallyInvoiceItemsByID(request) {
        return axiosGetAuthorize(GetOtherFormsManuallyInvoiceItemsByID, request);
    }

    // Material In
    async getAllDropdownAndCountsForOtherForms(request) {
        return axiosGetMultiParams(GetAllDropdownAndCountsForOtherForms, request);
    }

    async getMaterialOutSelect_ForMaterialIn(request) {
        return axiosGetMultiParams(USP_Transaction_MaterialOutSelect_ForMaterialIn, request);
    }

    async getGatePassSelectbyId(request) {
        return axiosGetAuthorize(USP_Extra_GatePassSelectbyId, request);
    }

    async getTransactionMaterialOutSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_MaterialOutSelectbyId, request);
    }

    async submitMaterialInInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_MaterialInInsertUpdate, request);
    }

    async getTransactionMaterialInSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_MaterialInSelectbyId, request);
    }

    // DisAssemble Transaction 
    async getTransactionSalesReturnForDisAssemble(request) {
        return axiosGetMultiParams(USP_Transaction_SalesReturn_ForDisAssemble, request);
    }

    async getMasterProductSelectForProductionStock(request) {
        return axiosGetMultiParams(USP_Master_ProductSelect_ForProductionStock, request);
    }

    async getMasterProductSelectForProductionStock2(request) {
        return axiosGetMultiParams(USP_Master_ProductSelect_ForProductionStock2, request);
    }

    async getTransactionDeliveryChallanProductQuantitySelectByID(request) {
        return axiosGetMultiParams(USP_Transaction_DeliveryChallanProductQuantitySelectByID, request);
    }

    async getTransactionSalesReturnProductsSelectbyId(request) {
        return axiosGetMultiParams(USP_Transaction_SalesReturnProductsSelectbyId, request);
    }

    async getMasterProductReceipeSelectForSalesReturnItem(request) {
        return axiosGetMultiParams(USP_Master_ProductReceipeSelect_ForSalesReturnItem, request);
    }

    async getMasterItemSelectbyIdForDisAssemble(request) {
        return axiosGetMultiParams(USP_Master_ItemSelectbyId_ForDisAssemble, request);
    }

    async getMasterProductReceipeSelectForDisAssembleItem(request) {
        return axiosGetMultiParams(USP_Master_ProductReceipeSelect_ForDisAssembleItem, request);
    }

    async getTransaction_DisAssembleSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_DisAssembleSelectbyId, request);
    }

    async submitDisAssembleInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_DisAssembleInsertUpdate, request);
    }

    // Stock tranfer
    async getStockTransfer(request) {
        return axiosGetMultiParams(USP_Transaction_WorkOrderRecvSelectbyId_PendingQty_ForStockTransfer, request);
    }

    async getTransactionStockTransferSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_StockTransferSelectbyId, request);
    }

    async submitStockTransferInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_StockTransferInsertUpdate, request);
    }

    // Employee Problems 
    async usp_Extra_EmployeeProblemSelectById(request) {
        return axiosGetAuthorize(usp_Extra_EmployeeProblemSelectById, request);
    }

    async usp_Extra_EmployeeProblemInsertUpdate(request) {
        return axiosPostAuthorize(usp_Extra_EmployeeProblemInsertUpdate, request);
    }

    // Store to plant
    async usp_Transaction_TransferLocationCount(request) {
        return axiosGetMultiParams(usp_Transaction_TransferLocationCount, request);
    }

    async usp_Master_ItemSelectForLocationTransfer(request) {
        return axiosGetAuthorize(usp_Master_ItemSelectForLocationTransfer, request);
    }

    async usp_Master_ProductReceipeSelectbyIdItemForStoreInPlant(request) {
        return axiosGetMultiParams(usp_Master_ProductReceipeSelectbyIdItemForStoreInPlant, request);
    }

    async usp_Master_ItemSelectByIdItemForTransferLocationStock(request) {
        return axiosGetMultiParams(usp_Master_ItemSelectByIdItemForTransferLocationStock, request);
    }

    async usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM(request) {
        return axiosGetMultiParams(usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM, request);
    }
    async usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM_Print(request) {
        return axiosGetFileAuthorizeblob(usp_Master_ProductReceipeSelectbyIdItemForStoreInPlantBOM_Print, request);
    }

    async usp_Transaction_TransferLocationInsertUpdate(request) {
        return axiosPostAuthorize(usp_Transaction_TransferLocationInsertUpdate, request);
    }

    async usp_Transaction_TransferLocationSelectById(request) {
        return axiosGetAuthorize(usp_Transaction_TransferLocationSelectById, request);
    }

    // Back to store
    async usp_Transaction_TransferLocationSelectTransferNo(request) {
        return axiosGetMultiParams(usp_Transaction_TransferLocationSelectTransferNo, request);
    }
    async usp_Transaction_TransferLocationSelectByIdForInward(request) {
        return axiosGetAuthorize(usp_Transaction_TransferLocationSelectByIdForInward, request);
    }
    async usp_Transaction_TransferLocationInwardInsertUpdate(request) {
        return axiosPostAuthorize(usp_Transaction_TransferLocationInwardInsertUpdate, request);
    }
    async usp_Transaction_TransferLocationInwardSelectById(request) {
        return axiosGetAuthorize(usp_Transaction_TransferLocationInwardSelectById, request);
    }
}